import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetTreatBalanceQuery,
  GetTreatBalanceQueryVariables,
} from "./TreatBalance.generated";

const TREAT_BALANCE_QUERY: TypedDocumentNode<
  GetTreatBalanceQuery,
  GetTreatBalanceQueryVariables
> = gql`
  query GetTreatBalance {
    treatBalance {
      totalBalance
      monthlyBalance
      permanentBalance
      nextResetAt
    }
  }
`;

export default TREAT_BALANCE_QUERY;
